export enum Onboardings {
  HOME = 'HOME',
  USUARIO_EDICAO_FIRST_PAGE = 'USUARIO_EDICAO_FIRST_PAGE',
  USUARIO_EDICAO_SECOND_PAGE = 'USUARIO_EDICAO_SECOND_PAGE',
  GRUPO_USUARIO = 'GRUPO_USUARIO'
}
